import { Dispatch, SetStateAction } from "react";
import NextItem from "../components/NextItem";
import BackButton from "../components/BackButton";
import { MainImage } from "../workDetailPage/WorkMainImage";
import Navigator from '../components/Navigation';
import { WorkFullImage } from "../workDetailPage/WorkFullImage";
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { ArticleMainImage } from "../articleDetailPage/ArticleMainImage";
import image1 from '../image/articles/adblock.webp';
import article2Thumbnail from '../image/articles/article2_1.webp';
import ProtectedPage from "../components/ProtectedPage";
import { hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Wavedivider } from "../components/Wavedivider";
import YouTubeEmbed from "../components/YouTubeEmbed";
import creative2Thumbnail from '../image/articles/article5-1.webp';
import { useMetaTags } from '../utils/useMetaTags';

function Creative1(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
    const hashedPasswords = hashPasswordsFromEnv(
      process.env.REACT_APP_CREATIVE1_PASSWORDS
    );
      const images1 = [image1]; // 1개 이미지
      const images2 = [image1, image1]; // 2개 이미지
      const images3 = [image1, image1, image1]; // 3개 이미지
      
      useMetaTags({
        title: '2024 당근 광고실 송년회 - Lynkim',
        description: '송년회 기록',
        image: '/ogimage.png',
      });
      
      return (
        // <ProtectedPage password={hashedPasswords} description="송년회에서 공연한 밴드의 이름을 입력해 주세요.">
        <>
          <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
          <div className='fadeIn '>
            <ArticleTitle
              title={'2024 당근 광고실 송년회'} 
              description={'송년회 기록'} 
              category={'creative'} 
              date={'2024.12.18.'}
              // thumbnail={image1}
              />
          </div>
          <Wavedivider/> 
          
          <div className='articleLayout'>
            <YouTubeEmbed videoId="1LtaXtBLG4Q" />
            <YouTubeEmbed videoId="E0oyCPQSoxA" />
          </div>
          
          <NextItem to='/creative2' thumbnail={creative2Thumbnail} nextProjectTitle='2024 당근 광고실 하반기 레크레이션'/>

          <BackButton/>
        </>
      )
  }
  
  export default Creative1;
